/* 当前位置路径 */
import React from 'react'
import classnames from 'classnames'
import Link from 'next/link'

import getLinkHref from 'lib/get-link-href'

interface IPath {
  [prop: string]: string
}

interface IProps {
  /* 当前页面路径 */
  path: IPath[]
  hideLine?: boolean
  style?: React.CSSProperties
  className?: string
}

export default function Breadcrumb({
  path,
  hideLine = false,
  style,
  className,
}: IProps) {
  return (
    <div style={style} className={className}>
      <p
        className={classnames({
          'hide-line': hideLine,
        })}
      >
        <span className="pos">当前位置：</span>
        {path.map((text: IPath, index: number) => (
          <span
            key={text.name}
            className={classnames({
              'pos-item': true,
              icon: index !== path.length - 1,
              'icon-arrow-ic-r': index !== 0,
            })}
          >
            {text.href && text.as ? (
              <Link href={text.href} as={getLinkHref(text.as)}>
                <a>{text.name}</a>
              </Link>
            ) : (
              text.name
            )}
          </span>
        ))}
      </p>
      <style jsx>
        {`
          .pos {
            font-size: 16px;
            color: #999999;
          }
          p.hide-line {
            border-bottom: 0;
          }
          div {
            width: 100%;
            height: 60px;
            line-height: 60px;
          }
          p {
            font-size: 16px;
            height: 100%;
            color: #999;
            border-bottom: 1px solid #ededed;
          }
          span {
            color: #1a1a1a;
          }
          .icon-arrow-ic-r {
            margin-top: -2px;
          }
          .icon-arrow-ic-r::before {
            margin: 0 8px;
            vertical-align: middle;
            height: 20px;
            line-height: 20px;
          }
          .inverse-color .pos-item {
            color: #ffffff;
          }
        `}
      </style>
    </div>
  )
}
